import * as yup from 'yup';
import { setIn } from 'final-form';

export const getValidator = (schema: yup.AnySchema) => async (values: any) => {
  try {
    await schema.validate(values, { abortEarly: false });
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      const errors = err.inner.reduce((formError, innerError) => setIn(formError, innerError.path ?? '', innerError.message), {});

      return errors;
    }
    console.error(err);
    throw err;
  }
};
